export default __webpack_public_path__ + "static/media/rtc_logo_page-0001.8a3e1e91.jpg";